module.exports = __webpack_public_path__ + "static/Banner-10-34f22e9da54f2c0693c2124d7f33ca88.png";